// Rotas da calculadora: /enem-gabarito-<ano>/*. O ano fica fixo na URL; uma
// edição nova entra no ar com o ano em ENEM_GABARITO_YEARS (deploy do morpheus).

export const ENEM_GABARITO_ROOT = '/enem-gabarito';

// Anos com rota própria
export const ENEM_GABARITO_YEARS: readonly number[] = [2026];

// URLs de anos sem edição que redirecionam para a página inicial de outro ano
export const ENEM_GABARITO_REDIRECTS: Readonly<Record<number, number>> = { 2025: 2026 };

export function enemGabaritoPaths(year: number) {
  const home = `${ENEM_GABARITO_ROOT}-${year}`;
  return {
    home,
    cadastro: `${home}/cadastro`,
    preencher: `${home}/preencher`,
    notasOficiais: `${home}/notas-oficiais`,
  };
}

export type EnemGabaritoPaths = ReturnType<typeof enemGabaritoPaths>;

const YEAR_IN_PATH = /^\/enem-gabarito-(\d{4})(?:\/|$)/;

/**
 * Ano de `/enem-gabarito-YYYY/*` com rota própria ou null
 */
export function editionYearFromPath(pathname: string): number | null {
  const match = YEAR_IN_PATH.exec(pathname);
  const year = match ? Number(match[1]) : null;
  return year && ENEM_GABARITO_YEARS.includes(year) ? year : null;
}

/**
 * Ano para onde `/enem-gabarito` leva quando a edição atual da API não tem rota
 * neste build (ex.: o backend abriu um ano novo antes do deploy do morpheus)
 */
export function routableEditionYear(year: number): number {
  return ENEM_GABARITO_YEARS.includes(year) ? year : Math.max(...ENEM_GABARITO_YEARS);
}
